///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export enum GtthInputTypesEnum {
    TEXTBOX = 'textbox',
    DROPDOWN = 'dropdown',
    CHECKBOX = 'checkbox'
}
